import { Typography } from "@mui/material";
import Script from "next/script";
import { FC, Fragment, PropsWithChildren, useCallback } from "react";

import { useTranslation } from "../fe-ui/hooks/use-translation";
import { env } from "../fe-ui/utils/env";

const reCAPTCHA_KEY = "6Le6vvomAAAAAOvxlJgynu0Qdh-Mw-cw3gtw_Dop";

export const RecaptchaController: FC<PropsWithChildren & { Wrapper?: FC<PropsWithChildren> }> = ({
  children,
  Wrapper = Fragment
}) => {
  const t = useTranslation();

  return (
    <>
      {env("RECAPTCHA_DISABLED") !== "true" && (
        <Script
          onLoad={() => {
            //
          }}
          src={`https://www.google.com/recaptcha/api.js?render=${reCAPTCHA_KEY}`}
        />
      )}
      {children}
      <Wrapper>
        <Typography variant={"body2"}>
          <small>
            {t.rich("recaptcha", {
              privacy: x => (
                <a rel="nofollow" target="_blank" href="https://policies.google.com/privacy">
                  {x}
                </a>
              ),
              terms: x => (
                <a rel="nofollow" target="_blank" href="https://policies.google.com/terms">
                  {x}
                </a>
              )
            })}
          </small>
        </Typography>
      </Wrapper>
    </>
  );
};

export const useRecaptchaCallback = (callback?: (token: string) => void) =>
  useCallback(
    () =>
      env("RECAPTCHA_DISABLED") === "true"
        ? new Promise(resolve => {
            callback?.("xxx");
            resolve("xxx");
          })
        : window["grecaptcha"]
            .execute("6Le6vvomAAAAAOvxlJgynu0Qdh-Mw-cw3gtw_Dop", { action: "CreateBooking" })
            .then(recaptchaToken => {
              callback?.(recaptchaToken);
              return recaptchaToken;
            }),
    []
  );
